import { render } from "./itemLocation.vue?vue&type=template&id=51bf969a"
import script from "./itemLocation.vue?vue&type=script&lang=js"
export * from "./itemLocation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__